module.exports = __webpack_public_path__ + "77cb7f85c9fc1a14d61ca67015597ee5.svg";